import keyMirror from 'keymirror';

export const ViewTypes = keyMirror({
  Loose: null,
  Compact: null,
  Featured: null,
  Display: null,
  Teleprompter: null,
  RemoteTeleprompter: null,
  GlobalElement: null,
  Grid: null,
  Responsive: null,
});

export const ViewRelativePaths = {
  Loose: 'desktop',
  Compact: 'desktop/compact',
  Featured: 'desktop/featured',
  Display: 'desktop/display',
  Teleprompter: 'desktop/teleprompter',
  RemoteTeleprompter: 'desktop/teleprompter/guest',
  GlobalElement: 'desktop/global',
  Grid: '/grid',
  Responsive: '/responsive/table',
};
